export default "__VITE_ASSET__BgiByRpH__"